<template>
  <div class="media-page">
    <!-- 顶部提示文字 -->
    <div class="tip-text">把脸移入框内</div>

    <!-- 圆形相机区域 -->
    <div class="camera-wrapper">
      <div class="camera-circle">
        <video
          ref="video"
          class="camera-video"
          autoplay
          playsinline
          muted
        ></video>
      </div>
      <!-- 人脸轮廓线稿 -->
      <img src="@/assets/auth/face-img.png" class="face-overlay" />
    </div>

    <!-- 底部按钮 -->
    <div class="btn-area">
      <button class="start-btn" @click="handleDetect">
        <span>拍摄</span>
      </button>
    </div>
  </div>
</template>

<script>
import { uploadImageAndCall } from "@/api/common";

export default {
  data() {
    return {
      id: this.$route.query.id,
      stream: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initCamera();
    });
  },
  beforeDestroy() {
    this.stopCamera();
  },
  methods: {
    getMediaAPI() {
      if (
        navigator.mediaDevices &&
        typeof navigator.mediaDevices.getUserMedia === "function"
      ) {
        return {
          getUserMedia: navigator.mediaDevices.getUserMedia.bind(
            navigator.mediaDevices,
          ),
          isLegacy: false,
        };
      }
      const legacyFn =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;
      if (typeof legacyFn === "function") {
        return {
          getUserMedia: (constraints) =>
            new Promise((resolve, reject) => {
              legacyFn.call(navigator, constraints, resolve, reject);
            }),
          isLegacy: true,
        };
      }
      return null;
    },

    async initCamera() {
      const mediaAPI = this.getMediaAPI();

      if (!mediaAPI) {
        const isSecure =
          window.location.protocol === "https:" ||
          window.location.hostname === "localhost" ||
          window.location.hostname === "127.0.0.1";
        if (!isSecure) {
          this.showTip("摄像头功能需要 HTTPS 环境，请检查访问地址");
        } else {
          this.showTip("当前浏览器不支持摄像头功能，请更换浏览器");
        }
        return;
      }

      try {
        const constraints = {
          video: {
            facingMode: "user",
            width: { ideal: 1280 },
            height: { ideal: 720 },
          },
          audio: false,
        };

        this.stream = await mediaAPI.getUserMedia(constraints);

        await this.$nextTick();
        const videoEl = this.$refs.video;
        if (videoEl) {
          videoEl.srcObject = this.stream;
          videoEl.play().catch((e) => {
            console.warn("video play() 失败:", e);
          });
        } else {
          console.error("video 元素未找到");
          this.showTip("页面渲染异常，请重试");
        }
      } catch (err) {
        console.error("摄像头调用失败:", err);
        let msg = "摄像头调用失败";
        if (
          err.name === "NotAllowedError" ||
          err.name === "PermissionDeniedError"
        ) {
          msg = "请允许摄像头权限";
        } else if (
          err.name === "NotFoundError" ||
          err.name === "DevicesNotFoundError"
        ) {
          msg = "未检测到摄像头设备";
        } else if (
          err.name === "NotReadableError" ||
          err.name === "TrackStartError"
        ) {
          msg = "摄像头被占，请关闭其他应用后重试";
        } else if (err.name === "OverconstrainedError") {
          msg = "摄像头参数不匹配";
        } else if (err.name === "NotSupportedError") {
          msg = "当前环境不支持摄像头，请使用 HTTPS 或 localhost";
        } else if (err.name === "SecurityError") {
          msg = "安全限制：请使用 HTTPS 或 localhost 访问";
        }
        this.showTip(msg);
      }
    },

    handleDetect() {
      const video = this.$refs.video;
      if (!video || !this.stream) {
        this.showTip("摄像头未就绪，请稍候");
        return;
      }

      // 拍照 → canvas → base64
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const base64Image = canvas.toDataURL("image/png");
      // 打印 base64
      console.log("拍照 base64:", base64Image);
      this.$toast({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      uploadImageAndCall({
        id: this.id,
        imgLiveDetectionBase64: base64Image,
      }).then((res) => {
        console.log("上传进件图片并调用原进件接口:", res);
        this.$toast.clear();
        this.$router.push({
          path: "/auth/success",
          params: {
            type: res.type,
          },
        });
      });
    },

    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }
    },

    showTip(msg) {
      this.$toast({
        message: msg,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.media-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  overflow: hidden;
  padding-top: 110px;
  background: #f5f5f5;
}

.tip-text {
  font-size: 28px;
  color: #8b7f7f;
  text-align: center;
  margin-bottom: 56px;
  font-weight: 500;
}

.camera-wrapper {
  position: relative;
  width: 490px;
  height: 490px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.camera-circle {
  width: 490px;
  height: 490px;
  border-radius: 50%;
  overflow: hidden;
}

.camera-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.face-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 490px;
  height: 490px;
  pointer-events: none;
  object-fit: contain;
}

.btn-area {
  width: 100%;
  padding: 0 5%;
  margin-top: 440px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

.start-btn {
  width: 654px;
  height: 98px;
  border: none;
  border-radius: 16px;
  background: #ff4741;
  color: #fff;
  font-size: 36px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
